<script lang="ts">
    import { TextInput } from "carbon-components-svelte";
    import { Button as CarbonButton, ButtonSet } from "carbon-components-svelte";
    import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32";
    import Save32 from "carbon-icons-svelte/lib/Save32";
    import { MultiSelect } from "carbon-components-svelte";
   
    import type { Role } from './jmdb'
    import { diffArray, role_list, deep_copy, newId, right_list, streamer_list, streamer_groups, isBuiltin } from './jmdb';

    import RightsEditor from './RightsEditor.svelte';
    import stringify from 'fast-json-stable-stringify'

    export let role : Role
    let in_flight = false
    
    let oldRole: Role = deep_copy(role)
    let dirty = false
    let rightsDirty = false

    let rightsStrings : string[] = role.rights.map(v=>v.toString())
    let rightsEditor: RightsEditor

    let oldRightsStrings: string[] = deep_copy(rightsStrings)

    $: rightsDirty = stringify(oldRightsStrings) != stringify(rightsStrings)
    $: dirty = (stringify(oldRole) != stringify(role)) || rightsDirty

    let built_in = false
    $: built_in = isBuiltin(role.id)
    
    let refetchRelevant = function(): Promise<any> {
        return Promise.all([
            streamer_list.fetch(),
            streamer_groups.fetch(),
            right_list.fetch(),
            role_list.fetch(),
        ])
    }

    let after_changes = (res: Response) => {
        if (!res.ok) {
            res.text().then((txt) => {
                window.alert(txt)
            })
            in_flight = false
        } else {
            role_list.invalidate()
            refetchRelevant().then(()=>{
                in_flight = false
            })
        }
    }
    let saveClicked = () => {
        let old = oldRole
        let rightsChanges = diffArray(oldRightsStrings.map(v=>Number(v)), rightsStrings.map(v=>Number(v)), (v)=>v, false)

        let changeBundle: any = {
            memberChanges: rightsChanges,
        }
        const matchedFields = ["name"]
        matchedFields.forEach(el => {
            if ((old as any)[el] != (role as any)[el]) {
                changeBundle[el] = (role as any)[el]
            }
        })
        rightsEditor.addModifications(changeBundle, old.specialRights)


        fetch("/api/v1/roles/"+role.id, {
            'method': 'POST',
            'body': JSON.stringify(changeBundle)
        }).then(after_changes)
        in_flight = true
    }

    let deleteClicked = (e: Event) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete "+role.name+"?")) {
            fetch("/api/v1/roles/"+role.id, {
                'method': 'DELETE',
                'body': JSON.stringify({})
            }).then(after_changes)
        }
    }
    refetchRelevant()

</script>

<TextInput disabled={built_in} bind:value={role.name} labelText="Name" placeholder="Enter permission set's display name"/>
    

<div>
    {#if $right_list.ready}
    <MultiSelect disabled={built_in}
        titleText="Has rights:"
        label={rightsStrings.map(v => $right_list.data.find(ag => ag.id.toString() == v) || {'name': "Not found"}).map(ag=>ag.name).join(', ') || "No rights"}
        items={$right_list.data.map(v => { return {id: v.id.toString(), val: v.id, text: v.name}})}
        bind:selectedIds={rightsStrings}
        />
        

    {/if}
</div>


<RightsEditor disabled={built_in} bind:this={rightsEditor} bind:rights={role.specialRights}/>

<ButtonSet stacked style="float: right;">
    <CarbonButton kind="primary" icon={Save32} disabled={!dirty || in_flight} on:click={saveClicked}>Save</CarbonButton>
    {#if role.id != newId}
    <CarbonButton kind="danger-ghost" disabled={built_in} icon={TrashCan32} tooltipPosition="left" on:click={deleteClicked}>Delete</CarbonButton>
    {/if}
</ButtonSet>
